export default class EstimateItem {
  id: string = "";
  unitName: string = "";
  unitType: string = "";
  unitPrice: number = 0;
  amount: number = 0;
  totalPrice: number = 0;
  unitLoss: number = 0;
  loss: number = 0;
  expenseCategoryId: string = "";
  memo: string = "";
  items: EstimateItem[] = [];
  purchased: boolean = false;
  level?: number = 0;
}
